import * as Scrivito from "scrivito"
import { ScrivitoPageBreadcrumb } from "scrivito/scrivito-breadcrumb/ScrivitoPageBreadcrumb"

import { BreadcrumbWidget } from "./BreadcrumbWidgetClass"
import "./styles/_breadcrumb-widget.scss"

const IGNORED_OBJECT_CLASSES: string[] = ["Homepage"]

Scrivito.provideComponent(BreadcrumbWidget, ({ widget }) => {
  const page = Scrivito.currentPage()
  const showHomepage = widget.get("showHomepage")

  return (
    <div className="breadcrumb-widget">
      <ScrivitoPageBreadcrumb
        page={page}
        ignoredObjClasses={showHomepage ? undefined : IGNORED_OBJECT_CLASSES}
      />
    </div>
  )
})
